import type { Committee } from "./types";
import art from "../images/art.svg";
import education from "../images/education.svg";
import action from "../images/action.svg";

// Single source of truth for the three subcommittees.
// Previously duplicated inline in both Home.tsx and Join.tsx.

/** Lead-in printed above each committee's task list. */
export const committeeTasksLeadIn = "This looks like:";

export const committees: Committee[] = [
  {
    id: "art",
    name: "Art Subcommittee",
    icon: art,
    intro:
      "Art Subcommittee members create digital and physical materials that get the word about our Detroit Divest campaign out there.",
    items: [
      "Using Canva (or any other digital design application) to create the flyers for our events",
      "Designing the zines and other physical, printed materials",
      "Tabling at events to inform people about the Detroit Divest Campaign and sell our tabling materials, which go to our organizing and Gaza mutual aid funds",
      "Designing and crafting goods (ex. pins, patches, etc.) to be sold at our table",
    ],
  },
  {
    id: "education",
    name: "Education Subcommittee",
    icon: education,
    intro:
      "Education Subcommittee members provide materials and put on events that educate people on the Detroit Divest Campaign.",
    items: [
      "Researching targets of the Detroit Divest Campaign",
      "Writing zines and materials for our social media",
      "Writing speeches for protests",
      "Putting on events that inform people of the Detroit Divest campaign and deepen our knowledge as anti-war and pro-Palestine activists",
    ],
  },
  {
    id: "action",
    name: "Action Subcommittee",
    icon: action,
    intro:
      "Action Subcommittee members plan, prepare, and carry out protests that respond to current events and strengthen our Detroit Divest Campaign in action.",
    items: [
      "Choosing locations and targets",
      "Mapping out routes",
      "Providing and training marshals and medics for protests",
      "Leading in chants, banner-holding, passing out waters, and other day-of tasks at protests",
    ],
  },
];
